export const DefaultFullscreenAPI = {
  canFullScreen: () => false,
  goFullscreen: () => {},
  closeFullscreen: () => {},
  getFullScreen: () => false
};

const FullScreenApi = {
  requestFullscreen: {
    canFullScreen: elm => !!elm?.requestFullscreen,
    goFullscreen: elm => elm.requestFullscreen(),
    closeFullscreen: () => document.exitFullscreen(),
    getFullScreen: () => !!document.fullscreenElement
  },
  /* iphone Safari */
  webkitEnterFullscreen: {
    canFullScreen: elm => !!elm?.webkitEnterFullscreen,
    goFullscreen: elm => elm.webkitEnterFullscreen(),
    closeFullscreen: () => document.webkitExitFullscreen(),
    getFullScreen: elm => !!elm?.webkitDisplayingFullscreen
  },
  /* Safari */
  webkitRequestFullscreen: {
    canFullScreen: elm => !!elm?.webkitRequestFullscreen,
    goFullscreen: elm => elm.webkitRequestFullscreen(),
    closeFullscreen: () => document.webkitExitFullscreen(),
    getFullScreen: () => !!document.webkitFullscreenElement
  },
  mozRequestFullScreen: {
    canFullScreen: elm => !!elm?.mozRequestFullScreen,
    goFullscreen: elm => elm.mozRequestFullScreen(),
    closeFullscreen: () => document.mozCancelFullScreen(),
    getFullScreen: () => !!document.mozFullScreenElement
  },
  /* IE11 */
  msRequestFullscreen: {
    canFullScreen: elm => !!elm?.msRequestFullscreen,
    goFullscreen: elm => elm.msRequestFullscreen(),
    closeFullscreen: () => document.msExitFullscreen(),
    getFullScreen: () => !!document.msFullscreenElement
  }
};

export function getFullscreenApi(elem) {
  return (
    Object.values(FullScreenApi).find(api => api.canFullScreen(elem)) ||
    DefaultFullscreenAPI
  );
}
